import styles from "./FilterChip.module.css";

export type ChipTone =
  | "neutral"
  | "pending"
  | "approved"
  | "scheduled"
  | "published"
  | "failed"
  | "rejected";

interface FilterChipProps {
  label: string;
  count: number;
  tone?: ChipTone;
  active: boolean;
  onClick: () => void;
}

/** Status filter pill with a live count. Matches queue-web.jsx `FilterChip`. */
export function FilterChip({ label, count, tone = "neutral", active, onClick }: FilterChipProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`${styles.chip} ${active ? styles.active : ""} ${styles[`t_${tone}`]}`}
    >
      {label}
      <span className={styles.count}>{count}</span>
    </button>
  );
}
